import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div
      className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6"
      data-testid="notfound-page"
    >
      <Compass size={40} className="text-tw-yellow mb-4" strokeWidth={1.5} />
      <div className="font-mono text-[10px] tracking-[0.3em] text-tw-muted uppercase mb-2">Fout 404</div>
      <h1 className="font-display text-3xl sm:text-4xl font-black text-white tracking-tight mb-3">
        Deze pagina bestaat niet.
      </h1>
      <p className="text-tw-muted text-sm max-w-sm mb-6">
        De link klopt niet (meer) of de pagina is verplaatst.
      </p>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="tw-press inline-flex items-center gap-2 px-5 h-11 bg-tw-yellow text-black font-bold uppercase tracking-[0.15em] text-xs"
      >
        Terug naar start
      </Link>
    </div>
  );
}
